import RoomCharacterEdit from './RoomCharacterEdit.vue';
export default RoomCharacterEdit;
